import TR from 'utils/TR';
import T from 'utils/T';
import ex from 'utils/ex';
import DAY_ZONE_TYPES from 'constants/DAY_ZONE_TYPES';
import * as Luxon from 'luxon';
import React from 'react';
import ABNORMAL_GLOCOSE_TYPES from 'constants/ABNORMAL_GLOCOSE_TYPES';
import CHECK_COLORS from 'constants/CHECK_COLORS';

const types = {
  'max': T('최고'),
  'min': T('최저'),
};

export default function BloodGlocoseDialogGlocoseTable(props) {
  const {
    data,
    type,
  } = props;

  const {
    bldsugr_graph_list = [],
    // bld_sugr_time,
    // bld_sugr_value,
    // max_bld_sugr_yn,
    max_bldsugr_time,
    min_bldsugr_time,
    max_bldsugr_time_zone_tp_cd,
    bldsugr_before_meal,
    // max_bldsugr,
    // min_bldsugr,
    postprand2h_bldsugr,
    postprand2h_bldsugr_rise_w,
    postprand2h_bldsugr_tp,
    postprand_abnrml_bldsugr_min,
    main_food_list = [],
    // intaken_time,
    // main_food_nm,
    // main_food_cal,
    total_intaken_cal,
    carbo_rate,
    protein_rate,
    fat_rate,
    postprand_active_time,
    postprand_step_cnt,
    postprand_burn_cal,
    bolus_cnt,
    bolus_amt,
    bolus_time,
  } = data;

  const time = React.useMemo(() => {
    if (data[`${type}_bldsugr_time`]) {
      return Luxon.DateTime.fromFormat(data[`${type}_bldsugr_time`], 'yyyyMMddHHmmss').toFormat('HH:mm');
    } else {
      return '';
    }
  }, [data, type]);

  return (
    <table>
      <tbody>
        <tr>
          <th>
            <div>
              {T('이상혈당 종류')}
            </div>
          </th>
          <td>
            <div>
              {ABNORMAL_GLOCOSE_TYPES[postprand2h_bldsugr_tp]}
            </div>
          </td>
        </tr>
        <tr>
          <th>
            <div>
              {T('{0}혈당 발생시간', types[type])}
            </div>
          </th>
          <td>
            <div>
              {time} ~ {DAY_ZONE_TYPES[+data[`${type}_bldsugr_time_zone_tp_cd`] - 1]}
            </div>
          </td>
        </tr>
        <tr>
          <th>
            <div>
              {T('{0}혈당', types[type])}
            </div>
          </th>
          <td>
            <div {...ex(['BASE_COLOR', CHECK_COLORS('B', data[`${type}_bldsugr`])])}>
              {data[`${type}_bldsugr`]} mg/dL
            </div>
          </td>
        </tr>
        {/* <tr>
          <th>
            <div>
              {T('식전혈당')}
            </div>
          </th>
          <td>
            <div {...ex(['BASE_COLOR', CHECK_COLORS('B', bldsugr_before_meal)])}>
              {bldsugr_before_meal} mg/dL
            </div>
          </td>
        </tr>
        <tr>
          <th>
            <div>
              {T('식후 2시간 혈당')}
            </div>
          </th>
          <td>
            <div {...ex(['BASE_COLOR', CHECK_COLORS('B', postprand2h_bldsugr)])}>
              {postprand2h_bldsugr} mg/dL
            </div>
          </td>
        </tr> */}
        <tr>
          <th>
            <div>
              {T('혈당{0}폭', type === 'max' ? T('상승') : T('하강'))}
            </div>
          </th>
          <td>
            <div>
              {postprand2h_bldsugr_rise_w === 0 ? '' : 0 < Math.sign(postprand2h_bldsugr_rise_w) ? '+' : '-'}{postprand2h_bldsugr_rise_w} mg/dL
            </div>
          </td>
        </tr>

        <tr>
          <th>
            <div>
              {T('이상혈당 도달시간')}
            </div>
          </th>
          <td>
            <div>
              {postprand_abnrml_bldsugr_min}분
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  );
}
